import { render } from "./App.vue?vue&type=template&id=94eb8e9e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=94eb8e9e&lang=css"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__